import clsx from 'clsx'

import { useTalentCardContext } from '../Context'
import TalentCardPaperSvg from '../TalentCardPaperSvg'

import './style.scss'
import {PropsWithChildren} from 'react'

interface TalentCardPaperProps {
    className?: string,
    isBackground?: boolean
    style? : React.CSSProperties
}

const TalentCardPaper: React.FC<TalentCardPaperProps & PropsWithChildren> = ({ style, isBackground, className, children }) => {
    const { onClick } = useTalentCardContext()

    return (
        <div
            style={style}
            className={clsx(className, 'talentcard-paper', { 'talentcard-paper--is-background': isBackground })}
        >
            <TalentCardPaperSvg
                isBackground={isBackground}
            />

            <div
                tabIndex={-1}
                role='button'
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        onClick?.()
                    }
                }}
                onClick={onClick}
                className='talentcard-paper__overlay'
            >
                {children}
            </div>

            <img
                alt='Logo'
                src='/assets/logo_with_text_white.svg'
                className='talentcard-paper__logo'
            />
        </div>
    )
}

export default TalentCardPaper
